import React from 'react';
import { N1_MATCH_DETAIL } from '../../../common/routing';
import RouteLink from '../../../common/routing/RouteLink';
import clsx from 'clsx';

//TODO: tento komponent sa prestane pouzivat, ked sa detail zapasu bude zobrazovat v modali
export const MatchDetailLink = ({ matchId, meta = null, children, ...rest }) => {
    const cssClass = 'ellipsis f-condensed text-extra-bold c-black-100 pr-10';
    return (
        <RouteLink routePath={N1_MATCH_DETAIL} params={{ eventId: matchId, meta }} className={clsx(cssClass)} {...rest}>
            {children}
        </RouteLink>
    );
};
